import { render, staticRenderFns } from "./email-holder.vue?vue&type=template&id=547faa0c&scoped=true"
import script from "./email-holder.vue?vue&type=script&lang=ts"
export * from "./email-holder.vue?vue&type=script&lang=ts"
import style0 from "./email-holder.vue?vue&type=style&index=0&id=547faa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547faa0c",
  null
  
)

export default component.exports